import * as React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../core/store/interfaces";
import { useConfiguration } from "../../../../core";
import moment from "moment";
import api from "../../../../api";
import {
  LeadRequirement,
  RequirementStageCodes,
  RequirementStatus,
} from "../../../../core/api/models/requirement";
import AddNewRequirement from "../actions/AddNewRequirement";
import { useHistory } from "react-router-dom";
import { RouteKeys } from "../../../routes/route-keys";

const RequirementList: React.FunctionComponent<{
  onReload?: () => void;
}> = (props) => {
  const history = useHistory();

  const [viewMore, setViewMore] = React.useState<boolean>(false);
  const leadState = useSelector((state: State) => state.lead);
  const requirements = leadState?.leadDetails?.requirements;
  const { openModal } = useConfiguration(api);
  const [showAddNewRequirement, setShowAddNewRequirement] = React.useState(false);

  const handleRequirementNavigation = (requirement: LeadRequirement) => {
    if (!requirement.stageCode) {
      return history.push(`${RouteKeys.Requirement.replace(":id", requirement?._id)}`);
    }

    if (
      [RequirementStageCodes.Agreement, RequirementStageCodes.Invoice].includes(
        requirement.stageCode
      )
    ) {
      return history.push(
        `${RouteKeys.Agreement.replace(":id", requirement.masterRequirementId || requirement._id)}`
      );
    }
    history.push(
      `${RouteKeys.Proposal.replace(":id", requirement.masterRequirementId || requirement._id)}`
    );
  };

  return !!requirements?.length ? (
    <>
      <div className="px-4 py-2 bg-gray-100 border-top border-bottom d-flex align-items-center">
        <h6 className="mb-0">Requirement ({requirements?.length})</h6>
        <i
          className="icon-plus-sm icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto bg-white font-xs"
          onClick={() => setShowAddNewRequirement(true)}
        ></i>
      </div>

      {requirements?.slice(0, viewMore ? requirements.length : 2).map((requirement, index) => {
        return (
          <div
            className={`d-flex pl-4 pr-2 py-3 font-xs position-relative vehicle-blk d-flex flex-wrap cursor-pointer border-bottom`}
            onClick={() => handleRequirementNavigation(requirement)}
          >
            <div className=" w-100 col-9 px-0">
              <div className="font-weight-bold text-truncate mb-1">
                {requirement.microMarketDetails?.map((x) => x.cityZoneName).join(",")}{" "}
              </div>
              <div className="w-100 pl-0 font-weight-semibold mb-1">
                <span className="text-muted">Availability</span> :{" "}
                {requirement?.propertiesCount || 0} properties,
                {requirement?.projectsCount || 0} projects
              </div>
              <div className="w-100 pl-0 font-weight-semibold d-flex align-items-center mb-1">
                <span className="text-gray-500 pr-1">City</span> {"  "}:{"  "}
                <span className="font-weight-bold pl-1 pr-1">
                  {requirement.cityDetails?.cityName}
                </span>
              </div>
              <div className="w-100 pl-0 font-weight-semibold d-flex align-items-center">
                {requirement.createdBy ? (
                  <>
                    {/* <span className="dot-separator d-inline-block bg-gray-400 rounded-circle mx-2"></span> */}
                    <span className="text-gray-500 pr-1">Created By</span> {"  "}:{"  "}
                    <span className="text-muted font-weight-bold pl-1 pr-1">
                      {requirement.createdBy?.name}{" "}
                    </span>
                  </>
                ) : (
                  <>Created</>
                )}{" "}
                <span className="text-gray-500 pl-1 pr-1">on</span>
                <span className="text-muted font-weight-bold pl-1">
                  {moment(requirement?.createdAt).format("DD MMM YYYY hh:mm A")}
                </span>
              </div>
            </div>
            <div className="col-3 px-0">
              <div
                className="bg-gray-100 border px-1  ml-auto font-sm font-weight-semibold text-capitalize"
                style={{ width: "min-content" }}
              >
                <span className="" style={{ width: "fit-content" }}>
                  {requirement?.stageStatus
                    ? requirement?.stageStatus
                    : requirement.status === RequirementStatus.Pending
                    ? "Draft"
                    : requirement.status}
                </span>
              </div>
            </div>
          </div>
        );
      })}
      {requirements.length > 2 && (
        <div className="d-flex align-items-center px-4 py-2">
          <button
            className="btn btn-link font-xs p-0 font-weight-semibold"
            onClick={() => setViewMore(!viewMore)}
          >
            {viewMore ? "View Less" : `View More (${requirements.length - 2})`}
          </button>
        </div>
      )}
      {showAddNewRequirement && (
        <AddNewRequirement
          className="row mx-0"
          lead={leadState?.leadDetails}
          leadId={leadState?.leadDetails?._id || ""}
          customerId={leadState?.leadDetails?.customer?._id || ""}
          onClose={() => setShowAddNewRequirement(false)}
          onReload={() => {
            props.onReload?.();
          }}
        ></AddNewRequirement>
      )}
    </>
  ) : (
    <></>
  );
};

export default RequirementList;
